/**
 * 称号模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取称号列表
export const titleList = (params) => {
  return req.get('/system/title/list', params);
}

// 新增称号
export const titleAdd = (params) => {
  return req.post('/system/title', params);
}

// 修改称号信息
export const titleEdit = (params) => {
  return req.put('/system/title', params);
}